import api from "../../../utils/api"
const apiUrl = process.env.REACT_APP_MOCK_RESUME_URL;

export const createSubscription = async(data) => {
  try {
    const res = await api.post(
      `/plans/customPlans`,
      data,
      { baseURL:  apiUrl}

    );
    return res;
  } catch (err) {
    return err;
  }
}